exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".anketa__description[data-v-d4344346]{font-family:Open Sans,sans-serif;font-weight:400;line-height:1.35;margin-bottom:14px;padding:0 12px;font-size:16px;color:#666}.anketa__body[data-v-d4344346]{padding:18px 12px 36px;background-color:#f4f4f4;border-radius:2px}.anketa__slider[data-v-d4344346]{margin-bottom:36px;padding-bottom:22px;border-bottom:1px solid #d8d8d8}.anketa__btn[data-v-d4344346]{max-width:300px;margin:0 auto;display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d4344346","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/anketa/Anketa.vue
// module id = 8f05d65cd0dbc6296271
// module chunks = 6